module.exports = __webpack_public_path__ + "images/umzug.png?e1cb4d199e60c34a485c89c9d28f205a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/umzug.png
// module id = 7SAv
// module chunks = 0